module.exports = __webpack_public_path__ + "media/application/images/ui/kiwi-icon-reversed-077947f221e0afffe8898374c4f00b25.png";